import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { TOOLS } from '../data/catalog';

const Automation = () => {
  const [flipped, setFlipped] = useState({});

  const toggle = (name) => setFlipped((f) => ({ ...f, [name]: !f[name] }));

  return (
    <section className="band band-line" id="automation">
      <div className="wrap">
        <motion.div
          className="section-head"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="eyebrow-dark">Automation Toolbelt</span>
          <h2>Infrastructure, provisioned and configured as code</h2>
          <p>Tap a card to see how each tool is used in a JbnWorks delivery pipeline.</p>
        </motion.div>

        <div className="tool-grid">
          {TOOLS.map((t) => (
            <div
              key={t.name}
              className={`tool-card ${flipped[t.name] ? 'flipped' : ''}`}
              onClick={() => toggle(t.name)}
              onMouseLeave={() => setFlipped((f) => ({ ...f, [t.name]: false }))}
            >
              <div className="tool-card-inner">
                <div className="tool-face tool-front">
                  <div className="t-name">{t.name}</div>
                  <div className="t-cat">{t.cat}</div>
                </div>
                <div className="tool-face tool-back">{t.back}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Automation;
